<template>
  <ul class="orderInfo">
    <li>
      <div class="th">下单时间</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.createTime||'--' }}</div>
    </li>
    <li>
      <div class="th">预约日期</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.bookDate || '--' }}</div>
    </li>
    <li>
      <div class="th">预约时间</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.startTime?orderDeatilsData.bookOrderMsgDTO.startTime+'~'+orderDeatilsData.bookOrderMsgDTO.endTime:'--' }}</div>
    </li>
    <li>
      <div class="th">预约来源</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.buySource == 0 ? '电脑端' : orderDeatilsData.bookOrderMsgDTO.buySource == 1 ? '粉丝端' : orderDeatilsData.bookOrderMsgDTO.buySource == 2 ? '店员APP' : 'Smartbox' }}</div>
    </li>
    <li>
      <div class="th">预约项目</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.itemName || '--' }}</div>
    </li>
    <li>
      <div class="th">预约{{ Lib.collectively() }}</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.technicianName || '到店安排' }}</div>
    </li>
    <li>
      <div class="th">服务时长</div>
      <div class="td">{{ orderDeatilsData.serviceTime+'分钟' }}</div>
    </li>
    <li>
      <div class="th">操作人</div>

      <div class="td">{{ orderDeatilsData.dutyName?orderDeatilsData.dutyName:orderDeatilsData.bookOrderMsgDTO.bookStatus?getBespeakVal(orderDeatilsData.bookOrderMsgDTO.bookStatus):'--' }}</div>
    </li>
    <li class="liALL">
      <div class="th thAll">预约备注</div>
      <div class="td">{{ orderDeatilsData.bookOrderMsgDTO.remark || '--' }}</div>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
    };
  },
  activated() {
  },
  methods: {
    getBespeakVal(val) {
      return val == -3 ? '顾客' : val == -4 ? '商家拒绝' : '';
    },
  }
};
</script>
<style lang="less" scoped>
</style>
